import React, {Component} from 'react';
import './list.css';
import './contentimg_list.css';
import Constant from "./constant.js"
import {
    getContentPictureList,
    saveStoryFilePicture,
    setInfoToLocalStorage,
    getInfoFromLocalStorage,
    contentPictureCount,
    saveContributeStoryFilePicture
} from '../../actions'
import {Button, List, Pagination, Spin} from "antd";
import {connect} from "react-redux";
import $ from 'jquery'
import {HEADER_HEIGHT} from "../../constants";
import {applicationName, formatDate} from "../../utils";


const leftStyle = {
    marginRight: "5px"
};

//不要随便删除下面   global layer * 这个代码
/* global layer */
class ContentImgList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            count: 0,
            page: 1,
            size: Constant.configPagesize,
            start: 1,
            currentStoryId: 0,
            loading: false,
            disabled:false,
            height: applicationName() == 'pms' ? window.innerHeight - HEADER_HEIGHT - 172 : window.innerHeight - HEADER_HEIGHT - 272,
        }
    }


    showOnlyFileUploadDialog() {

        let that = this;
        let x = "930px";
        let y = "640px";
        if (applicationName() == "pms") {
            x = "750px";
            y = "680px";
        }

        let parent;
        if (applicationName() == 'pms') {
            parent = window.parent;
        } else {
            parent = window.frames[0];
        }

        this.setState({
            disabled:true,
        })

        parent.layer.open({
            title: '上传文件',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/upload/uploadfile.html?fileBtnName=选择文件&storyContentImg=true&uploadFileAfterFun=FileConvertParams&deleteFileAfterFun=delteTempFile&setFileNumFun=setFileNumFun&resourceType=2&onlyUploadFile=true',
            area: [x, y],
            resize: false,
            btn: ['选择文件', '一键上传', '保存', '关闭'],
            cancel: function (index, layero) {
                that.setState({
                    disabled:false,
                })
                window.layer.close(index);
            },
            success: function (layero, index) {
                let openPage = parent[layero.find('iframe')[0]['name']];
                // openPage.$("#myAlert").show();
            },
            end: function (index, layero) {
                that.setState({
                    disabled:false,
                })
            },
            yes: function (index, layero) {
                let openPage = parent[layero.find('iframe')[0]['name']];
                openPage.$("#batchWebUpload").click();
            },
            btn2: function (index, layero) {
                let openPage = parent[layero.find('iframe')[0]['name']];
                openPage.startAll();
                return false;
            },
            btn3: function (index, layero) {
                let openPage = parent[layero.find('iframe')[0]['name']];
                var tempResults = openPage.tempResults;
                var orginalContentImgids = JSON.parse(sessionStorage.getItem("storyContentImgids"));
                if(applicationName()=='pms'){
                    that.savePmsPic(tempResults,orginalContentImgids)
                }else{
                    that.saveContributePic(tempResults,orginalContentImgids)
                }
            }
        });
    }


    /**
     * 保存contribute的值；
     */
    saveContributePic(tempResults,orginalContentImgids) {
        let that=this;
        let tempResultsCount=tempResults.length;
        let count=0;
        $.each(tempResults, function (index, item) {
            var result = tempResults[index];
            var fileTemp = {};
            fileTemp.imageHeight = result.storageFile.height;
            fileTemp.imageWidth = result.storageFile.width;
            // 1-投稿 2-约稿 3-线索 4-采访 5-资源上传 6-融媒
            fileTemp.dataSource = 1;
            fileTemp.name = result.storageFile.name;
            fileTemp.ext = result.storageFile.suffix;
            fileTemp.path = result.url;
            fileTemp.size = result.storageFile.size ? result.storageFile.size : 0;
            fileTemp.storyId = 0;
            fileTemp.md5 = result.storageFile.md5;
            //保存图片；
            saveContributeStoryFilePicture(fileTemp, function (resu) {
                var data = resu;
                //处理返回数据；
                console.info("saveStoryFilePicture", data);
                //把resourceIds放到sessionStorage中，然后从写稿页面取；
                if (data) {
                    //把resourceIds放到sessionStorage中，然后从写稿页面取；
                    if (orginalContentImgids.indexOf(data.resourceId) < 0) {
                        orginalContentImgids.push(data.resourceId);
                    }

                    setInfoToLocalStorage("storyContentImgids", orginalContentImgids);

                    //重新加载稿件内容图片列表
                    let param = {
                        "start": that.state.start,
                        "size": that.state.size,
                        "resourceIds": orginalContentImgids.join(",")
                    };
                    count++;
                    if(count==tempResultsCount){
                        getContentPictureList(param, that.updatePictureList.bind(that));
                    }
                }
            })
        });
    }


    savePmsPic(tempResults,orginalContentImgids){
        let that=this;
        let tempResultsCount=tempResults.length;
        let count=0;
        $.each(tempResults, function (index, item) {
            var result = tempResults[index];
            var params = {};
            var files=[];
            var fileTemp={};
            fileTemp.imageHeight = result.storageFile.height;
            fileTemp.imageWidth = result.storageFile.width;
            // 1-投稿 2-约稿 3-线索 4-采访 5-资源上传 6-融媒
            fileTemp.dataSource = 1;
            fileTemp.name = result.storageFile.name;
            fileTemp.ext = result.storageFile.suffix;
            fileTemp.path = result.url;
            fileTemp.size = result.storageFile.size ? result.storageFile.size : 0;
            fileTemp.storyId = 0;
            files.push(fileTemp);
            params.pictures=files;
            fileTemp.md5 = result.storageFile.md5;
            //保存图片；
            saveStoryFilePicture(JSON.stringify(params), function (resu) {
                var data=resu[0]
                //处理返回数据；
                console.info("saveStoryFilePicture", data);
                //把resourceIds放到sessionStorage中，然后从写稿页面取；
                if (data) {
                    //把resourceIds放到sessionStorage中，然后从写稿页面取；
                    if (orginalContentImgids.indexOf(data.resourceId) < 0) {
                        orginalContentImgids.push(data.resourceId);
                    }

                    setInfoToLocalStorage("storyContentImgids", orginalContentImgids);

                    //重新加载稿件内容图片列表
                    let param = {
                        "start": that.state.start,
                        "size": that.state.size,
                        "resourceIds": orginalContentImgids.join(",")
                    };
                    count++;
                    if(count==tempResultsCount){
                        getContentPictureList(param, that.updatePictureList.bind(that));
                    }
                }
            })
        });
    }

    // 在组件即将被挂载到页面的时刻执行
    componentWillMount() {
        let parent;
        if (applicationName() == 'pms') {
            parent = window.parent;
        } else {
            parent = window.frames[0];
        }
        let currentStoryId = parent.currentStoryId;
        console.log('ContentImgList  currentStoryId', currentStoryId);
        if (!currentStoryId) {
            return;
        }
        this.setState({
            loading: true,
        })

        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }
        let param = {
            "resourceIds": getInfoFromLocalStorage("storyContentImgids").join(","),
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": this.state.start,
            "size": this.state.size
        };
        getContentPictureList(param, this.updatePictureList.bind(this));
    }

    updatePictureList(result) {
        //传递总数
        this.setState({
            loading: false,
        })

        if (result) {
            this.props.contentPictureCount(result.count?result.count:0);
            this.setState({
                data: result.data,
                loading: false,
                count: result.count
            });
        }

    }


    /**
     * 图片预览功能
     * @param record
     */
    imageTopreview(record) {

        let data = {
            "pictureList": [{
                "path": record.path,
                "desc": record.name
            }
            ],
            "title": record.name
        };

        let parent;
        if (applicationName() == 'pms') {
            parent = window.parent;
        } else {
            parent = window.frames[0];
        }

        parent.layui.config({
            base: '/cm-sites/layuiadmin/modules/' //静态资源所在路径
        }).extend({
            index: 'lib/index' //主入口模块
        }).use(['storage'], function () {
            let content = '/cm-sites/' + window.env + '/previewMedia/atlas-view.html';
            var storage = parent.layui.storage;
            storage.set("current-atlas", data);

            parent.layer.open({
                type: 2,
                area: ['800px', '600px'],
                title: data.title,
                content: content
            });
        });
    }


    insertPicture(data) {

        //contribute和pms使用的编辑器不一样，所以调用的方法也不一样
        if (applicationName() == 'contribute') {

            let param = {
                "alt": data.name,
                "floatStyle": "",
                "src": data.path,
                "width": 500,
                // "height":data.ZykPicture_imageHeight,
                "title": "",
                "_src": data.path
            }
            let list = []
            list.push(param);
            window.frames[0].ueditor.execCommand('insertimage', list);

            let param2 = {
                "success": true,
                "url": data.path,
                "smallUrl": data.path,
                "middleUrl": data.path,
                "storageFile": {
                    "_id": "",
                    "duration": 0,
                    "height": data.imageHeight,
                    "md5": "",
                    "name": data.name,
                    "path": data.path,
                    "prefix": "",
                    "size": 0,
                    "storageDirectoryId": [],
                    "suffix": data.ext,
                    "type": 1,
                    "url": "",
                    "width": 500
                },
                "state": "",
                "title": "",
                "original": data.name,
            }
            window.frames[0].cmSitesFileUploadAfterCallbackFun(param2);
        } else {
            let param = {
                "alt": data.name,
                "floatStyle": "",
                "src": data.path,
                "title": "",
                "_src": data.path,
                "width": 500,
                "border": "0",
                "vspace": "0"
            }
            let list = []
            list.push(param);
            window.parent.ueditor.execCommand('insertimage', list);

            let param2 = {
                "success": true,
                "url": data.path,
                "smallUrl": data.path,
                "middleUrl": data.path,
                "storageFile": {
                    "_id": "",
                    "duration": 0,
                    "height": data.imageHeight,
                    "md5": "",
                    "name": data.name,
                    "path": data.path,
                    "prefix": "",
                    "size": 0,
                    "storageDirectoryId": [],
                    "suffix": data.ext,
                    "type": 1,
                    "url": "",
                    "width": 500
                },
                "state": "",
                "title": "",
                "original": data.name,
            }
            window.parent.cmSitesFileUploadAfterCallbackFun(param2);
        }
    }


    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.tableKey === 6) {
            let onlyMe = 1;
            if (nextProps.onlyMe) {
                onlyMe = 0
            }

            let param = {
                "resourceIds": getInfoFromLocalStorage("storyContentImgids").join(","),
                "query": nextProps.searchText,
                "isAll": onlyMe,
                "start": 1,
                "size": this.state.size
            };
            //请求后台获取稿件列表数据
            getContentPictureList(param, this.updatePictureList.bind(this));
        }
    }


    addHoverRemark() {
        $(".pictureList").on('mouseenter', '.image-box', function () {
            $(this).find(".image-remake").animate({bottom: "0px"}, 300);
        })

        $(".pictureList").on('mouseleave', '.image-box', function () {
            $(this).find(".image-remake").animate({bottom: "-35px"}, 300);
        });
    }

    getZykPicturePageList(page, pageSize) {
        this.setState({
            loading: true,
        })

        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }

        this.setState({
            start: page
        })

        let param = {
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": page,
            "size": pageSize,
            "resourceIds": getInfoFromLocalStorage("storyContentImgids").join(",")
        };
        //请求后台获取图片列表数据
        getContentPictureList(param, this.updatePictureList.bind(this));
    }


    /**
     * 分词在页面高亮显示；
     * @param data
     */
    lightAnayWorldInList(data) {
        //按照优先级排序
        let listData = data.sort(function (a, b) {
            return b.length - a.length
        });
        // for(var i=0;i<data.length;i++){
        //定义正则表达式对象  array[i]是关键字   "g"是指全局范围
        let a = new RegExp(listData.join("|"), "g");
        $(".content-header").each(function () {
            var html = $(this)[0].getAttribute('title')
            html = html.replace(a, function (item) {
                return "<span style='color:#F00'>" + item + "</span>"
            });
            $(this).html(html);
        });
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.tableKey === 6) {
            console.info("picture_list");
            //分词处理，分词高亮显示；
            if (this.props.searchText) {
                let param = {
                    str: this.props.searchText
                }
                //请求后台获取分词数据
                this.lightAnayWorldInList([this.props.searchText]);
                // getAnalyze(param, this.lightAnayWorldInList.bind(this));
            } else {
                $(".content-header").each(function () {
                    if ($(this).find('span')[0] && $(this).find('span')[0].style) {
                        $(this).find('span')[0].style.color = '#000';
                    }
                });
            }
        }
    }

    componentDidMount() {
        this.addHoverRemark();
    }

    /**
     * 删除稿件内容图片
     */
    deleteContentImg(id){
        var orginalContentImgids = JSON.parse(sessionStorage.getItem("storyContentImgids"));
        var index=orginalContentImgids.indexOf(id);
        orginalContentImgids.splice(index,1);
        setInfoToLocalStorage("storyContentImgids", orginalContentImgids);

        //重新加载稿件内容图片列表
        let param = {
            "start": this.state.start,
            "size": this.state.size,
            "resourceIds": orginalContentImgids.join(",")
        };
        getContentPictureList(param, this.updatePictureList.bind(this));
    }

    //高亮显示，搜索
    render() {
        return (
            <Spin spinning={this.state.loading}>
                <div>
                    <div className='pictureList' style={{height: this.state.height + 'px', overflow: "auto"}}>
                        <List
                            itemLayout="vertical"
                            size="large"
                            dataSource={this.state.data}
                            renderItem={item => (
                                <List.Item>
                                    <List.Item.Meta
                                        // avatar={<Avatar src={item.avatar} />}
                                        title={<div className="item-box">
                                            <div className="image-box" onClick={() => {
                                                this.insertPicture(item)
                                            }}>
                                                <img src={item.path}/>
                                                <div className="image-remake">
                                                    插入正文
                                                </div>
                                            </div>
                                            <div className={"content-box content-box-" + applicationName()}>
                                                <p className={"content-header image-name" + applicationName()}
                                                   title={item.name}>{item.name}</p>
                                                <p className="content-img-size"><span
                                                    style={{cursor: 'pointer', color: "#0050B3"}}
                                                    onClick={this.imageTopreview.bind(this, item)}>预览  </span>{item.imageWidth}*{item.imageHeight}
                                                    <span
                                                        style={{cursor: 'pointer', color: "#0050B3"}}
                                                        onClick={()=>{this.deleteContentImg(item.resourceId)}}>删除</span>
                                                </p>
                                                <p className="content-bottom">
                                                <span
                                                    className='zykresource'>来源:{Constant.getDataSource(item.dataSource)}</span>
                                                    <span className='zykdate'
                                                          title={formatDate(item.createDate.time)}>日期:{formatDate(item.createDate.time)}</span>
                                                </p>
                                            </div>
                                        </div>}
                                    />
                                </List.Item>
                            )}
                        />
                    </div>
                    <div className='pageTables'>
                        <div className={"zyk_foot_left"}>
                        <Pagination current={this.state.start} showLessItems={true} total={this.state.count}
                                    defaultPageSize={this.state.size}
                                    defaultCurrent={1}
                                    onChange={(page, pageSize) => {
                                        this.getZykPicturePageList(page, pageSize)
                                    }} onShowSizeChange={(page, pageSize) => {
                            this.getZykPicturePageList(page, pageSize)
                        }}/>
                        </div>
                        <div className={"zyk_foot_right"}>
                        <Button style={{...leftStyle}} type={"primary"} icon={"cloud-upload"}  disabled={this.state.disabled}
                                onClick={(e) => this.showOnlyFileUploadDialog(e)}>上传图片</Button>
                        </div>
                    </div>
                </div>
            </Spin>

        );
    }
}

function mapStateToProps(state) {
    return {
        searchText: state.zykReducer.searchText,
        onlyMe: state.zykReducer.onlyMe,
        tableKey: state.zykReducer.tableKey,
        doSearch: state.zykReducer.doSearch
    }
}


function mapStateToMethod(dispatch) {
    return {
        contentPictureCount: function (zykContentPictureCount) {
            return dispatch(contentPictureCount(zykContentPictureCount));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(ContentImgList);
